import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { SelectionModel } from '@angular/cdk/collections';
import { AppTextService } from '@fi-shared/app-text';
import { FiMediaBankDownloadData } from '../media-bank';

@Component({
    selector: 'fi-media-bank-download-dialog',
    template: `
        <mat-selection-list>
          @for (downloadItem of data; track downloadItem) {
            <mat-list-option [checkboxPosition]="'before'">
              <div class="size-label">
                {{ getQualityText(downloadItem) }}
                <span class="resolution">{{ downloadItem.width + ' x ' + downloadItem.height }}</span>
              </div>
              <fi-file-size [fileSize]="downloadItem.size"></fi-file-size>
            </mat-list-option>
          }
        </mat-selection-list>
        `,
    styleUrls: ['./fi-media-bank-download-dialog.component.scss'],
    host: { class: 'fi-media-bank-download-dialog' },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiMediaBankDownloadDialogComponent
    extends FiDialogsContentBase<FiMediaBankDownloadData[], FiMediaBankDownloadData>
    implements OnInit, AfterViewInit
{
    @ViewChild(MatSelectionList, { static: true }) private selectionList: MatSelectionList;

    private selectedItem: FiMediaBankDownloadData;

    ngOnInit() {
        this.selectionList.selectedOptions = new SelectionModel<MatListOption>(false);
        this.selectionList.selectionChange.subscribe((newSelection: MatSelectionListChange) => {
            this.selectedItem = null;
            const option: MatListOption = newSelection.options.length ? newSelection.options[0] : undefined;
            if (option && option.selected) {
                const selectedItemIndex = this.selectionList.options.toArray().indexOf(option);
                if (selectedItemIndex !== -1) {
                    this.selectedItem = this.data[selectedItemIndex];
                }
            }
            this.injector.get(ChangeDetectorRef).markForCheck();
        });
    }

    ngAfterViewInit(): void {
        let selectedItemIndex = this.data.findIndex((item) => item.quality === 'source');
        if (selectedItemIndex === -1 && this.data.length) {
            selectedItemIndex = 0;
        }
        if (selectedItemIndex !== -1) {
            this.selectedItem = this.data[selectedItemIndex];
            this.selectionList.selectedOptions.select(this.selectionList.options.toArray()[selectedItemIndex]);
            this.injector.get(ChangeDetectorRef).detectChanges();
        }
    }

    isYesButtonDisabled(): boolean {
        return !this.selectedItem;
    }

    getResult() {
        return this.selectedItem ? this.selectedItem : null;
    }

    getQualityText(downloadItem: FiMediaBankDownloadData) {
        if (downloadItem.quality === 'source')
            return this.injector.get(AppTextService).get('mediaModule.original').toLowerCase();
        return downloadItem.quality;
    }
}
